import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "phone",
})
export class PhonePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (!value || value == null) return "";
    let phone: string = value.replace(/\s/g, "");

    if (phone.length != 10) {
      return phone;
    }

    phone =
      "(" +
      phone.slice(0, 3) +
      ") " +
      phone.slice(3, 6) +
      "-" +
      phone.slice(6, 10);
    return phone;
  }
}
